import { isEnrolledInCourse } from "seneca-common/features/enrollments/features/course-enrollments/state";
import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";
import {
  analyticsCategories,
  AnalyticsEventsRegister,
  logGTMTrackingEvent,
  makeAnalyticsEvent
} from "seneca-common/utils/senecaAnalytics";

import { courseCrudStateConfig } from "../state/const";

type State = any;

const { fetchActionTypes } = makeCrudStateActionFactories(
  courseCrudStateConfig
);

const makeCourseAnalyticsEvent = () =>
  makeAnalyticsEvent(analyticsCategories.COURSE);

AnalyticsEventsRegister.addEventGenerators({
  // @ts-ignore
  [fetchActionTypes.FETCH_COURSE_SUCCESS]: makeCourseAnalyticsEvent
});

export const analyticsLogOpenStartCourseScreen = (
  courseId: string,
  isPremiumCourse: boolean,
  state: State
) => {
  const enrolled = isEnrolledInCourse(state, courseId);

  if (!enrolled) {
    logGTMTrackingEvent(
      {
        category: analyticsCategories.COURSE,
        event: "seneca/course/OPEN_START_COURSE_SCREEN",
        payload: {
          courseId,
          isPremiumCourse
        }
      },
      state
    );
  }
};
